<template>
  <CustomPage :noTitle="true">
    <div slot="content" class="content">
      <CustomHead
        :title="act_detail.name"
        backgroundColor="#C82D26"
        :boxShadow="true"
        ref="CustomHead"
        @sharePoster="sharePoster"
        :showFocusBtn="true"
        @focusClick="focusClick"
        :focusFlag="focusFlag"
      />
      <div class="banner">
        <img :src="act_detail.banner" alt="" />
      </div>
      <div class="scroll-wrapper">
        <Tabs
          v-model="active"
          scrollspy
          sticky
          :offset-top="tabs_height"
          :swipe-threshold="3"
        >
          <Tab
            v-for="item in list"
            :title="item.themeName"
            :key="item.actThemeId"
          >
            <component
              :is="panel_c(item.themeType)"
              :data="item"
              :contantBackground="contantBackground"
            />
          </Tab>
        </Tabs>
      </div>
      <CustomView />

      <!-- 二维码弹框 -->
      <QRCodeDialog ref="QRCodeDialog" />
      <!-- 入群享好礼图片 -->
      <!-- //这里relateAssociationStatus数据要变 src要变-->
      <!-- 等下放 -->

      <img
        :src="require('@/assets/activityplace/shareGoodGift.png')"
        alt=""
        class="shareGoodGiftImg"
        @click="showQRcodeDialog"
        v-if="relateAssociationStatus"
      />
    </div>
  </CustomPage>
</template>

<script>
import CustomView from '@/components/custom-view.vue'
import CustomPage from '@/components/custom-page.vue'
import CustomHead from '@/components/custom-head'
import { getActTheme, getActivityDetail } from './webApi'
import { forwardDetail, priceMarkup } from '@/api/forward'
import { getFollowInfo, follow, unfollow } from '@/api/follow'
import PanelBrand from '@/components/activity/panel/brand'
import PanelGoods from '@/components/activity/panel/goods'
import PanelSuit from '@/components/activity/panel/suit'
import { Tabs, Tab, Toast } from 'vant'
import { getQRCode } from '@/api/QRCode'
import QRCodeDialog from '@/components/QRCodeDialog'
export default {
  name: 'ActivityPlaceIndex',
  components: {
    CustomView,
    CustomPage,
    CustomHead,
    PanelBrand,
    PanelGoods,
    PanelSuit,
    Tabs,
    Tab,
    QRCodeDialog,
  },
  data() {
    return {
      tabs_height: 0,
      active: 0,
      focusFlag: false,
      focusId: false,
      act_detail: {
        name: null,
        actId: null,
        banner: null,
        description: null, // 活动描述
      },
      list: [],
      relateAssociationStatus: null,
      contantBackground: null,
    }
  },
  computed: {
    panel_c() {
      return (type) => {
        switch (type) {
          case 'brand':
            return 'PanelBrand'
          case 'goods':
            return 'PanelGoods'
          case 'suit':
            return 'PanelSuit'
        }
      }
    },
  },
  created() {
    this.getData()
    this.getFocusFlag()

    //根据返回数据 ，控制二维码图片的显示隐藏
    getQRCode({
      actId: this.$route.params.aid || localStorage.getItem('aidBannerPage'),
    })
      .then((res) => {
        // console.log(res, 1111111)
        localStorage.setItem('aidBannerPage', this.$route.params.aid)
        this.relateAssociationStatus = res.data
      })
      .catch((err) => {
        console.log(err)
      })
  },
  mounted() {
    this.tabs_height = this.$refs.CustomHead.$el.offsetHeight
  },
  methods: {
    getData() {
      const params = this.$route.params.aid
      getActivityDetail(params).then((res) => {

        if (res.data.state === 'FINISHED') {
          Toast('活动已结束')
          this.$router.back()
        } else {
          this.act_detail.name = res.data.name
          this.act_detail.actId = res.data.actId
          this.act_detail.banner = res.data.banner
          this.act_detail.description = res.data.description
        }
        this.$store.dispatch('app/showLoading')
        getActTheme(params)
          .then((_res) => {
            this.$store.dispatch('app/hideLoading')
            this.list = this.converData(_res.data, res.data.actServiceList)
            this.contantBackground = res.data.colorCode
          })
          .catch(() => {
            this.$store.dispatch('app/hideLoading')
          })
      })
    },
    converData(data, partServices) {
      const res_data = data.map((item) => {
        if (item.themeType === 'brand') {
          item.themeBrandList.forEach((_item) => {
            _item.partServices = partServices
          })
        }
        if (item.themeType === 'suit') {
          item.themeSuitH5List.forEach((_item) => {
            _item.partServices = partServices
          })
        }
        if (item.themeType === 'goods') {
          item.themeGoodsList.forEach((_item) => {
            _item.partServices = partServices
          })
        }
        return item
      })
      console.log(res_data)
      return res_data
    },
    async sharePoster() {
      try {
        this.$store.dispatch('app/showLoading')
        const detail = await this.getSharePosterDetail({
          actId: this.act_detail.actId,
          forwardType: 'ACTIVITY',
        })
        const forwardUrl =
          `${window.location.origin}/activityPlace/${this.act_detail.actId}?` +
          `customerId=${this.$store.state.user.forwardId}`
        const img = await this.getSharePosterImg({
          actId: this.act_detail.actId,
          forwardType: 'ACTIVITY',
          price: detail.price,
          urlAddress: forwardUrl,
        })

        this.sharePosterOpen(img.url, forwardUrl)
        this.$store.dispatch('app/hideLoading')
      } catch (error) {
        this.$store.dispatch('app/hideLoading')
      }
    },
    sharePosterOpen(url, forwardUrl) {
      this.$store.dispatch('sharePoster/show', {
        url,
        title: this.act_detail.name,
        desc: this.act_detail.description,
        link: forwardUrl,
        imgUrl: this.tools.getFirstGoodsImg(this.list),
      })
    },
    // 获取海报数据
    getSharePosterDetail(data) {
      return new Promise((resolve, reject) => {
        forwardDetail(data)
          .then((res) => {
            resolve(res.data)
          })
          .catch(() => {
            reject()
          })
      })
    },
    // 生成海报图片
    getSharePosterImg(data) {
      return new Promise((resolve, reject) => {
        priceMarkup(data)
          .then((res) => {
            resolve(res.data)
          })
          .catch(() => {
            reject()
          })
      })
    },
    // 获取是否关注
    getFocusFlag() {
      const params = this.$route.params.aid
      getFollowInfo(params).then(({ data }) => {
        if (data) {
          this.focusFlag = true
          this.focusId = data.id
        } else {
          this.focusFlag = false
        }
      })
    },
    // 关注
    focusClick() {
      if (this.focusFlag) {
        const params = { id: this.focusId }
        this.$store.dispatch('app/showLoading')
        unfollow(params)
          .then((res) => {
            this.$store.dispatch('app/hideLoading')
            this.getFocusFlag()
          })
          .catch(() => {
            this.$store.dispatch('app/hideLoading')
          })
      } else {
        const params = { actBrandId: this.$route.params.aid, type: true }
        this.$store.dispatch('app/showLoading')
        follow(params)
          .then((res) => {
            this.$store.dispatch('app/hideLoading')
            this.getFocusFlag()
          })
          .catch(() => {
            this.$store.dispatch('app/hideLoading')
          })
      }
    },

    showQRcodeDialog() {
      // 二维码弹框展示

      this.$refs.QRCodeDialog.open(this.relateAssociationStatus)
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #e82035;
  padding-top: 100px;
  .custom-head {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .banner {
    img {
      width: 100%;
    }
  }
  .scroll-wrapper {
    position: relative;
    flex: 1;
    min-height: 0;
    .van-tabs {
      & /deep/ .van-sticky {
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.14);
        .van-tabs__wrap {
          height: 76px;
          .van-tab {
            padding: 0 12px;
            color: #e82035;
            transition: 0.1s;
            &.van-tab--active {
              color: #fff;
              background-color: #e82035;
            }
          }
          .van-tabs__line {
            display: none;
          }
        }
      }

      //之前不要了
      // & /deep/ .van-tabs__content {
      //   // padding-bottom: 100px;
      // }
    }
  }
}

.shareGoodGiftImg {
  width: 120px;
  height: 90px;
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
